import { EMPTY_STRING } from 'common/constants';
import { LAST_ACCESS_TOKEN_KEY } from './constants';
import {
  encrypt,
  decrypt,
  isCryptoSupported,
} from 'common/utils/crypto/storageEncryption';

let accessToken: string = EMPTY_STRING;
let isIdentifyToken: boolean = false;

export const getAccessToken = () => accessToken;
export const getIsIdentifyToken = () => isIdentifyToken;

export const setAccessToken = async (
  value: string,
  isIdentify: boolean = false,
) => {
  accessToken = value;

  try {
    // Шифруем токен перед сохранением, если браузер поддерживает Web Crypto API
    const dataToStore = isCryptoSupported()
      ? await encrypt(JSON.stringify(value))
      : JSON.stringify(value);

    window.sessionStorage.setItem(LAST_ACCESS_TOKEN_KEY, dataToStore);
  } catch (error) {
    console.error('Error saving access token:', error);
    // Fallback: сохраняем без шифрования
    window.sessionStorage.setItem(LAST_ACCESS_TOKEN_KEY, JSON.stringify(value));
  }

  if (isIdentify) {
    isIdentifyToken = isIdentify;
  }
};

export const deleteAccessToken = () => {
  accessToken = EMPTY_STRING;
  // window.sessionStorage.removeItem(LAST_ACCESS_TOKEN_KEY);
};

export const getLastAccessToken = async (): Promise<string> => {
  try {
    const storedData = window.sessionStorage.getItem(LAST_ACCESS_TOKEN_KEY);
    if (!storedData) {
      return EMPTY_STRING;
    }

    // Пытаемся расшифровать, если данные зашифрованы
    const decryptedData = isCryptoSupported()
      ? await decrypt(storedData)
      : storedData;

    return JSON.parse(decryptedData) || EMPTY_STRING;
  } catch (error) {
    console.error('Error retrieving access token:', error);
    // Fallback: пытаемся парсить как обычный JSON
    try {
      const storedData = window.sessionStorage.getItem(LAST_ACCESS_TOKEN_KEY);
      return JSON.parse(storedData as string) || EMPTY_STRING;
    } catch {
      return EMPTY_STRING;
    }
  }
};
